import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { WithTranslation, withTranslation } from 'react-i18next';
import { MultiColumnsSelectItemModel } from '../forms/TwoColumnsSelect';
import Select from '../forms/Select';

interface MandatoryItemSelectModalProps extends WithTranslation {
  options: MandatoryItemSelectModel[];
  selectedOptions: MandatoryItemSelectModel[];
  title: string;
  onSave: (selectedValues: any) => void;
  toggle: () => void;
  isOpen: boolean;
}

interface MandatoryItemSelectModalState {
  selectedOptions: MandatoryItemSelectModel[];
  multiSelectItems: MultiColumnsSelectItemModel[];
}

export interface MandatoryItemSelectModel {
  value: string;
  label: string,
  isNew: boolean,
  collectedByBroker: boolean,
  index?: number
}

class MandatoryItemSelectModal extends React.PureComponent<MandatoryItemSelectModalProps, MandatoryItemSelectModalState> {

  readonly state = {
    selectedOptions: [] as MandatoryItemSelectModel[],
    multiSelectItems: [] as MultiColumnsSelectItemModel[]
  };

  componentDidUpdate(prevProps: MandatoryItemSelectModalProps) {
    if (this.props.isOpen && prevProps !== this.props) {

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        selectedOptions: this.props.selectedOptions
      });
    }
  }

  onSelect = (value: MandatoryItemSelectModel, inx?: number) => {
    if (inx !== undefined) {
      const selectedOptions = [] as MandatoryItemSelectModel[];
      this.setState((prevState) => {
        prevState.selectedOptions.forEach((o: MandatoryItemSelectModel) => {
          if (o.index === inx) {
            o.value = value.value;
            o.label = value.label;
          }
          selectedOptions.push(o);
        });
        return { selectedOptions: selectedOptions };
      });
    }
  };

  addRow = () => {
    const prevIndex = this.state.selectedOptions[ this.state.selectedOptions.length - 1 ]?.index;
    this.setState(prevState => ({
      selectedOptions: [ ...prevState.selectedOptions, {
        value: '',
        label: '',
        isNew: true,
        collectedByBroker: true,
        index: prevIndex !== undefined ? prevIndex + 1 : 0
      } ]
    }));
  };

  removeRow = (inx?: number) => {
    if (inx !== undefined) {
      const selectedOptions = this.state.selectedOptions.filter((o) => o.index !== inx);

      let index = 0;
      selectedOptions.forEach((o) => {
        o.index = index;
        index++;
      });
      this.setState(prevState => ({ selectedOptions: selectedOptions }));
    }
  };

  changeCollectedByBroker = (inx?: number) => {
    if (inx !== undefined) {
      const selectedOptions = [] as MandatoryItemSelectModel[];
      this.setState((prevState) => {
        prevState.selectedOptions.forEach((option: MandatoryItemSelectModel) => {
          const selectedOption = option;
          if (selectedOption.index === inx) {
            selectedOption.collectedByBroker = !option.collectedByBroker;
          }
          selectedOptions.push(selectedOption);
        });
        return { selectedOptions: selectedOptions };
      });
    }
  };

  render() {
    const { t } = this.props;

    return (
      <Modal style={{ minWidth: '960px' }} isOpen={this.props.isOpen} toggle={this.props.toggle}
             autoFocus={false}>
        <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
        <ModalBody>
          <div className="scrolling-modal-div-large">
            <table className="mandatory-item-table table table-borderless">
              <thead className="border-bottom">
              <tr>
                <th className="text-left">Item name</th>
                <th className="text-center">Collected by broker</th>
                <th className="text-center"></th>
              </tr>
              </thead>
              <tbody>
              {this.state.selectedOptions.map((o: MandatoryItemSelectModel, inx) => {
                return (
                  <tr key={o.index}>
                    <td className="text-left">{
                      !o.isNew && o.value != '' ? this.props.options.find(option => option.value === o.value)?.label
                        :
                        <Select
                          value={o}
                          className="mr-1"
                          placeholder="Select item"
                          options={this.props.options.filter(option => this.state.selectedOptions.every(so => so.value !== option.value))}
                          closeMenuOnSelect={true}
                          isMulti={false}
                          hideSelectedOptions={false}
                          disableClear
                          disableMinWidth
                          elWidth={400}
                          zIndex={1000 - inx}
                          label="option"
                          isDisabled={false}
                          onChange={(value) => this.onSelect(value as MandatoryItemSelectModel, o.index)}
                        />
                    }</td>
                    <td className="text-center">
                      <div className="custom-control custom-checkbox">
                        <input className="custom-control-input"
                               id={o.value}
                               checked={o.collectedByBroker}
                               type="checkbox"
                               disabled={false}
                               onChange={() => this.changeCollectedByBroker(o.index)}/>
                        <label className="custom-control-label" htmlFor={o.value}>
                        </label>
                      </div>
                    </td>
                    <td className="text-center">
                      <button type="button" className="remove-cross-btn" onClick={() => this.removeRow(o.index)}>
                        &times;
                      </button>
                    </td>
                  </tr>
                );
              })}
              </tbody>
            </table>
          </div>
          <div className="align-items-end d-flex justify-content-end mt-2">
            <button type="button" disabled={this.state.selectedOptions.length === this.props.options.length} className="btn btn-primary" onClick={() => this.addRow()}>ADD ITEM
            </button>
          </div>
        </ModalBody>
        <ModalFooter>
          <div>
            <button type="button" className="btn btn-outline-secondary mr-1"
                    onClick={this.props.toggle}>{t('b.cancel_Generic cancel button translation').toUpperCase()}</button>
            <button type="button" className="btn btn-primary" disabled={this.state.selectedOptions.findIndex(o => o.isNew && o.value === '') !== -1}
                    onClick={() => this.props.onSave(this.state.selectedOptions)}>{t('b.save_Generic save button translation').toUpperCase()}</button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }

}

export default withTranslation()(MandatoryItemSelectModal);
